import {ShiftEntity} from "@ots-frontend/ots-data";
import {GridColumnWithContent} from "../DataGrid/useDataGrid";
import {UseEntityDataGridProps} from "../EntityDataGrid/useEntityDataGrid";
import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {GridCellKind} from "@glideapps/glide-data-grid";
import {getFormattedDateTime} from "../../date/FormattedDateTime/FormattedDateTime";

export type UseShiftDataGridColsProps = Pick<UseEntityDataGridProps<ShiftEntity>, 'colWidths'>

export type UseShiftDataGridResult = {
  colsMap: GridColumnWithContent<ShiftEntity>[]
}

export function useShiftDataGridCols(props: UseShiftDataGridColsProps): UseShiftDataGridResult {
  const {colWidths} = props;

  const {t} = useTranslation(["common"])

  const colsMap: GridColumnWithContent<ShiftEntity>[] = useMemo(() => {
    let index = 0
    return [
      {
        title: "Driver",
        width: colWidths?.at(index++) ?? 100,
        hasMenu: true,
        getContent: (shift) => ({
          kind: GridCellKind.Text,
          data: shift?.personName ?? "",
          allowOverlay: false,
          displayData: shift?.personName ?? ""
        })
      },
      {
        title: "Vehicle",
        width: colWidths?.at(index++) ?? 100,
        hasMenu: true,
        getContent: (shift) => ({
          kind: GridCellKind.Text,
          data: shift?.vehicleName ?? "",
          allowOverlay: false,
          displayData: shift?.vehicleName ?? ""
        })
      },
      {
        title: "Trailer",
        width: colWidths?.at(index++) ?? 100,
        hasMenu: true,
        getContent: (shift) => ({
          kind: GridCellKind.Text,
          data: shift?.trailerName ?? "",
          allowOverlay: false,
          displayData: shift?.trailerName ?? ""
        })
      },
      {
        title: "Start",
        width: colWidths?.at(index++) ?? 100,
        hasMenu: true,
        getContent: (shift) => ({
          kind: GridCellKind.Text,
          data: shift?.startDttm ? getFormattedDateTime(shift.startDttm) : "",
          allowOverlay: false,
          displayData: shift?.startDttm ? getFormattedDateTime(shift.startDttm) : ""
        })
      },
      {
        title: "End",
        width: colWidths?.at(index++) ?? 100,
        hasMenu: true,
        getContent: (shift) => ({
          kind: GridCellKind.Text,
          data: shift?.endDttm ? getFormattedDateTime(shift.endDttm) : "",
          allowOverlay: false,
          displayData: shift?.endDttm ? getFormattedDateTime(shift.endDttm) : ""
        })
      }
    ]
  }, [colWidths, t])

  return {
    colsMap: colsMap
  }
}
